import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { faqs } from '../../data/mock';

const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <section className="bg-white py-16">
      <div className="container-main">
        <h2 className="text-3xl md:text-4xl font-bold text-navy font-display text-center mb-10">
          Have Any Question?
        </h2>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between px-6 py-4 text-left"
              >
                <span className="font-medium text-navy text-sm">{faq.question}</span>
                <Plus 
                  className={`w-5 h-5 text-navy shrink-0 transition-transform duration-200 ${
                    openFaq === faq.id ? 'rotate-45' : ''
                  }`} 
                />
              </button>
              {openFaq === faq.id && (
                <div className="px-6 pb-4 text-gray-600 text-sm">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
